/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomFieldDefinitionCategory } from './CustomFieldDefinitionCategory';
export type CustomFieldDefinition = {
    name: string;
    category?: CustomFieldDefinitionCategory;
    type: CustomFieldDefinition.type;
    required?: boolean;
    defaultValue?: string;
    options?: Array<{
        label: string;
        value: string;
    }>;
    mapping: (string | Array<string>);
    externalClientId?: string;
    visible?: boolean;
    visibleIf?: Array<{
        fieldName: string;
        value: string;
    }>;
    disabled?: boolean;
    validationRegex?: string;
    validationMessage?: string;
    description?: string;
};
export namespace CustomFieldDefinition {
    export enum type {
        INPUT_TEXT = 'INPUT_TEXT',
        LISTONLY = 'LISTONLY',
        LIST = 'LIST',
        SELECT_MANY_LIST = 'SELECT_MANY_LIST',
        DATE = 'DATE',
        TEXT_AREA = 'TEXT_AREA',
        CHECKBOX = 'CHECKBOX',
        PERSON_INFO = 'PERSON_INFO',
    }
}

